import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SectionContainer, SectionTitle } from '../styles';
import { Player } from './components/Player';
import { ImageContainer, ImageContainerWrapper, TitleContainer, } from './styles';
export const Media = ({ section }) => {
    return (_jsxs(SectionContainer, { children: [section.pageTitle && (_jsx(TitleContainer, { children: _jsx(SectionTitle, { children: section.pageTitle }) })), section.link ? (_jsx(Player, { link: section.link })) : (_jsx(ImageContainerWrapper, { children: _jsx(ImageContainer, { "$image": section.image }) }))] }));
};
